export default __webpack_public_path__ + "static/media/plus-icon.ee514b09.svg";